module.exports = __webpack_public_path__ + "img/img-location.5376fdc4.png";